import { FaTrash } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { FaTimes, FaSave } from "react-icons/fa";

import React, { useState } from "react";
import DeleteConfirmation from './ConfirmDelete';
const RetailItemRow = ({ item, index ,handleItemDelete,submission_status,editItem}) => {
    const [showModal, setShowModal] = useState(false);
    const [mode,setMode] = useState("view");

const [editData, setEditData] = useState({ ...item }); // <-- local editable copy

  // Enter edit mode and load current values
  const startEdit = () => {
    setEditData({ ...item });
    setMode("edit");
  };

  // Save changes
  const saveEdit = () => {
    //handleItemUpdate(item._id, editData); // parent updates backend/state
    editItem(editData);
    setMode("view");
  };


  function toFixedDigit(n, noOfDigits) {
    return n.toString().padStart(noOfDigits, '0');
}

function toFixedDigitFloat(n, noOfDigit, noOfDigitAfterDecimal) {
    let [intPart, decimalPart] = n.toFixed(noOfDigitAfterDecimal).split("."); // Ensures decimal part has fixed digits
    intPart = intPart.padStart(noOfDigit, "0"); // Zero-pad the integer part
    return `${intPart}.${decimalPart}`;
}


function numberToWords(num) {
  if (num === 0) return "Zero";

  const units = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  const scales = [
    { value: 10000000, name: "Crore" },
    { value: 100000, name: "Lakh" },
    { value: 1000, name: "Thousand" },
    { value: 100, name: "Hundred" }
  ];

  function helper(n) {
    let word = "";

    if (n < 10) word = units[n];
    else if (n < 20) word = teens[n - 10];
    else if (n < 100) word = tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + units[n % 10] : "");

    return word;
  }

  let result = "";
  let afterHundred = false; // flag to track if 'and' is needed

  for (const scale of scales) {
    if (num >= scale.value) {
      const scaledNum = Math.floor(num / scale.value);
      result += helper(scaledNum) + " " + scale.name + " ";
      num = num % scale.value;
      if (scale.value === 100) afterHundred = true;
    }
  }

  if (num > 0) {
    if (afterHundred) {
      result += "and ";
    }
    result += helper(num);
  }

  return result.trim();
}

  const handleChange = (e) => {
    const { name, value } = e.target;
    let parsedValue =
    name === 'name'
      ? value
      : Math.max(parseFloat(value) || 0, 0);
    
    setEditData((prev) => {
      const updated = {
        ...prev,
        [name]: parsedValue,
      };
  
      // Recalculate taxes and total if relevant fields change
      const amount = name === 'amount' ? parsedValue : updated.amount || 0;
      const igst = name === 'igst_percent' ? parsedValue : updated.igst_percent || 0;
      const cgst = name === 'cgst_percent' ? parsedValue : updated.cgst_percent || 0;
      const sgst = name === 'sgst_percent' ? parsedValue : updated.sgst_percent || 0;
  
      const igst_amount = (igst * amount) / 100;
      const cgst_amount = (cgst * amount) / 100;
      const sgst_amount = (sgst * amount) / 100;
      const total_amount =Math.round(amount + igst_amount + cgst_amount + sgst_amount);
  
      return {
        ...updated,
        igst_amount,
        cgst_amount,
        sgst_amount,
        total_amount,
      };
    });
  };


    return (
      <div
  className={`w-[300px] p-2 overflow-x-auto flex flex-col justify-center items-center m-1 rounded-lg 
    bg-gradient-to-r 
    ${submission_status === "submitted" ? "from-yellow-300 to-yellow-100" : "from-purple-300 to-purple-100"}`}
>

        {mode==="view" &&(<div
  className="flex flex-col justify-center items-center w-full"
>
          
          {/* Sl. No. - left aligned */}
          <div className="flex flex-col p-1  w-full items-center">
            <p className="text-[.8rem]">SlNo.</p>
            <p className="font-bold">{index + 1}</p>
          </div>
  
          {/* Description - right aligned */}
          <div className="flex flex-col p-1  w-full mt-1 items-center">
          <p className="text-[.8rem]">Descr.</p>
            <p className="font-bold">{item.name}</p>
          </div>
  
          <div className="flex flex-col p-1  w-full mt-1 items-center">
          <p className="text-[.8rem]">Rate</p>
            <p className="font-bold">{item.rate?item.rate:'__'}</p>
          </div>
  
          <div className="flex flex-col p-1  w-full mt-1 items-center">
          <p className="text-[.8rem]">Amount</p>
            <p className="font-bold">{item.amount}</p>
          </div>
  
          <div className="flex flex-col p-1  w-full mt-1 items-center">
          <p className="text-[.8rem]">IGST</p>
            <p  className="font-bold">
              {item.igst_amount} (@{item.igst_percent}%)
            </p>
          </div>
  
          <div className="flex flex-col p-1  w-full mt-1 items-center">
            
            <p className="text-[.8rem]">SGST</p>
            <p  className="font-bold">{item.sgst_amount} (@{item.sgst_percent}%)
            </p>
          </div>
  
          <div className="flex flex-col p-1  w-full mt-1 items-center">
          <p className="text-[.8rem]">CGST</p>
            <p  className="font-bold">
              {item.cgst_amount} (@{item.cgst_percent}%)
            </p>
          </div>
  
          <div className="flex flex-col p-1  w-full mt-1 items-center">
          <p className="text-[.8rem]">Item Total</p>
            <p className="font-bold">{item.total_amount}</p>
          </div>
          {submission_status!='submitted'&&(<div className="flex flex-col p-1 ">
                {submission_status!='submitted'  && submission_status!='cancelled' && (
                  <div className="flex justify-between  p-1 gap-2">
                  <button
  onClick={() => setShowModal(prev => !prev)}
  className={`flex items-center justify-center gap-2 px-1 py-2 text-white text-xs rounded-lg shadow-md transition duration-300
    ${true ? "bg-red-500 hover:bg-red-700" : "bg-gray-400 cursor-not-allowed"}`}
>
  <FaTrash className="w-3 h-3" />
  REMOVE ITEM
</button>

<button
 onClick={startEdit}
  className={`flex items-center justify-center gap-2 px-1 py-2 text-white text-xs rounded-lg shadow-md transition duration-300
    ${true ? "bg-blue-500 hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"}`}
>
  <FaEdit className="w-3 h-3" />
  EDIT ITEM
</button>

</div>)}
            </div>)}
        </div>)}

        {mode==="edit" &&(<div
  className="flex flex-col justify-center items-center w-full"
>
          
          {/* Sl. No. - left aligned */}
          <div className="flex flex-col p-1  w-full items-center">
            <p className="text-[.8rem]">SlNo.</p>
            <p className="font-bold">{index + 1}</p>
          </div>
  
           <div className='flex flex-col justify-center items-center w-full p-1'>
       <label>Description*:</label>
        <textarea
  name="name"
  value={editData.name}
  onChange={handleChange}
  onInput={(e) => {
    e.target.style.height = 'auto';
    e.target.style.height = `${e.target.scrollHeight+50}px`;
  }}
  placeholder="Item Name"
  className="w-full p-1 border rounded resize-y overflow-y-auto"
/></div>

 <div className='flex flex-col justify-center items-center w-full p-1'>
  <label>Rate:</label>
      <input
        type="number"
        name="rate"
        value={editData.rate}
        onChange={handleChange}
        placeholder="Rate" onWheel={(e) => e.target.blur()}
        className="w-full p-2 border rounded"
      />
</div>
 <div className='flex flex-col justify-center items-center w-full p-1'>
  <label>Amount*:</label>
      <input
        type="number"
        name="amount"
        value={editData.amount}
        onChange={handleChange}
        placeholder="Amount" onWheel={(e) => e.target.blur()}
        className="w-full p-2 border rounded"
      />  <p className='text-transparent'>{editData.amount||0}</p>
</div>

  <div className='flex flex-col justify-center items-center mt-4'><label>IGST%:</label>
        <input
          type="number"
          name="igst_percent"
          value={editData.igst_percent}
          onChange={handleChange}
          placeholder="IGST %"
          className="w-full p-2 border rounded" onWheel={(e) => e.target.blur()}
        />
        <p>{editData.igst_amount||0}</p>
        </div>
      <div className='flex flex-col justify-center items-center mt-4'> <label>SGST%:</label>
      <input
          type="number"
          name="sgst_percent"
          value={editData.sgst_percent}
          onChange={handleChange}
          placeholder="SGST %"
          className="w-full p-2 border rounded"  onWheel={(e) => e.target.blur()}
        /><p>{editData.sgst_amount||0}</p>
        </div>
      <div className='flex flex-col justify-center items-center mt-4'><label>CGST%:</label>
      <input
          type="number"
          name="cgst_percent"
          value={editData.cgst_percent}
          onChange={handleChange}
          placeholder="CGST %"
          className="w-full p-2 border rounded" onWheel={(e) => e.target.blur()}
        /><p>{editData.cgst_amount||0}</p>
       </div> 

<div className='flex flex-col justify-center items-center mt-4'>
        <p className="text-center">
            Item Total Amount:     </p>  
        <p className="text-center px-4">
        {toFixedDigitFloat(editData.total_amount||0,1,2)}
        </p>
        <p className="text-center px-4">
        ({numberToWords(editData.total_amount||0)})
        </p>

      </div>


          {submission_status!='submitted'&&(<div className="flex flex-col p-1 ">
                {submission_status!='submitted'  && submission_status!='cancelled' && (
                  <div className="flex justify-between  p-1 gap-2 mt-4">
                  <button
  onClick={() => setMode("view")}
  className={`flex items-center justify-center gap-2 px-1 py-2 text-white text-xs rounded-lg shadow-md transition duration-300
    ${true ? "bg-yellow-500 hover:bg-yellow-700" : "bg-gray-400 cursor-not-allowed"}`}
>
  <FaTimes className="w-3 h-3" />
  CANCEL EDIT
</button>

<button
  onClick={saveEdit}
  className={`flex items-center justify-center gap-2 px-1 py-2 text-white text-xs rounded-lg shadow-md transition duration-300
    ${true ? "bg-green-500 hover:bg-green-700" : "bg-gray-400 cursor-not-allowed"}`}
>
  <FaSave className="w-3 h-3" />
  SAVE EDIT
</button>

</div>)}
            </div>)}
        </div>)}

        <div className="w-full">
        <DeleteConfirmation
              isOpen={showModal}
              onCancel={() => setShowModal(false)}
              onDelete={() => {
                setShowModal(false);
                //call the actual delete function
                handleItemDelete(item._id);
              }}
              headerText="Confirm Delete"
              yesButtonText="DELETE"
              warningMessageText="Are you sure you want to DELETE the item?"
            />    

        </div>
      </div>
    );
  };
  
  export default RetailItemRow;
  